import { getNavigationRoutes } from "../../Config/routes";
import { TextField } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import BadgeLink from "../../Components/BadgeLink";

/**
 *
 * Moduuli softalle --> julkaisut, asennuksien lukumäärät ja kaatumiset
 * Moduuli laitteille --> ajot ja niiden tilastot == Dashboard
 * Moduuli siirroille --> uusimmat siirrot
 * Moduuli huollolle --> uusimmat tiketit ja huomautukset
 * Moduuli asiakkaille
 *
 * @param {*} props
 * @returns
 */

export default function ControlPanel(props) {
  const { t } = useTranslation();
  const [search, setSearch] = useState();
  const badgeLinks = getNavigationRoutes("controlPanel").map((route) => ({
    ...route,
    href: route.path,
    title: t(route.title),
  }));

  return (
    <Grid container justify="center">
      <Grid container spacing={3} justify="center" item md={12} lg={6}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            variant="outlined"
            label={t("search")}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          ></TextField>
        </Grid>
        {/* All the admin items as badges */}
        {badgeLinks
          .filter(
            (a) =>
              !search ||
              (search && a.title.toLowerCase().includes(search.toLowerCase()))
          )
          .sort((a, b) => {
            return a.title > b.title ? 1 : -1;
          })
          .map((b) => (
            <BadgeLink key={b.path} href={b.href} title={b.title} icon={b.icon} />
          ))}
      </Grid>
    </Grid>
  );
}
